import React, {Component} from 'react';
import {MoneyField, MoneyWithCurrencyField} from "buenLib/components/MoneyField";
import 'assets/sass/dashboard/deposits/withdraws/WithdrawSummary.scss';
import {CopyToClipboardElement} from "components/dashboard/common/CopyToClipboardElement";
import { AppContext } from 'app/state/AppContext';

export class WithdrawReceiptStep extends Component {
    static contextType = AppContext;

    render() {
        const form = this.props.withdrawForm;

        return (
            <div className="summary">
                <h1>¡Tu transferencia está siendo procesada!</h1>
                <p className="mb-4 text-center">Te recordamos que la velocidad de esta transferencia depende de la
                    congestión de la blockchain.</p>
                <div className="receipt-box">
                    <div className="box-header">
                        <p>Comprobante de transferencia</p>
                        <div className="user d-block d-sm-none">
                            {form.walletAddress()}
                        </div>
                        <div className="money">
                            <span
                                className="currency">{form.currency().code()}</span>
                            <span className="price">
                                <MoneyField value={form.amountField().value()} currency={form.currency()}/>
                            </span>
                        </div>
                    </div>
                    <div className="data coin">
                        {this.renderWalletAddress(form)}
                        {this.renderFee(form)}
                        {this.renderDate()}
                        {this.renderBlockchainTxId(form)}
                    </div>
                    <div className="text-center">
                        {/*<button className="cta-button">DESCARGAR COMPROBANTE</button>*/}
                    </div>
                </div>
            </div>
        );
    }

    renderDate() {
        return this.renderSummaryDataField(new Date().toLocaleDateString("es"), "Fecha");
    }

    renderWalletAddress(form) {
        return <div className="data-row">
            <span className="label">Dirección</span>
            <span className="value wallet-address">
                <CopyToClipboardElement content={<span className="copy-link">{form.walletAddress()}</span>}
                                        valueToCopy={form.walletAddress()}
                                        mouseOverTooltipMessage="Clickeá para copiar la dirección"
                                        copiedTooltipMessage="¡Dirección copiada al portapapeles!"/>
            </span>
        </div>;
    }

    renderFee(form) {
        const fee = form.fee() || 0;
        if (fee > 0) {
            let moneyField = <MoneyWithCurrencyField value={fee.toString()} currency={form.currency()}/>;
            return this.renderSummaryDataField(moneyField, "Comisión");
        }
    }

    renderBlockchainTxId(form) {
        let blockchainTxId = form.blockchainTxId();
        if (blockchainTxId) {
            return <div className="data-row">
                <span className="label">Blockchain Tx ID</span>
                <span className="value wallet-address"><a href={`https://etherscan.io/tx/${blockchainTxId}`}
                                                          rel="noopener noreferrer"
                                                          target="_blank">{blockchainTxId}</a></span>
            </div>;
        }
    }

    renderSummaryDataField(data, label) {
        if (data) {
            return <div className="data-row">
                <span className="label">{label}</span>
                <span className="value">{data}</span>
            </div>;
        }
    }

}
